import { supabase } from './supabase'
import { orderToRow } from './orders/rows'
import type { AdminUser, OrderLine } from '../types'
import { toDayKey } from '../utils/dayKey'
import { getDeviceCode } from '../utils/deviceId'

/** Kiosk ekranının sipariş sonrası gösterdiği: sıra no, karekod, kod. */
export interface KioskReceipt {
  id: string
  takeawayNo: number | null
  trackToken: string | null
  pickupCode: string | null
}

/**
 * Kiosk siparişi (30 Eki 2026, supabase/kiosk.sql): masasız, açık, ödeme
 * bekliyor. Çevrimdışı kuyruğa girmiyor, doğrudan yazılıyor: müşteriye sıra
 * numarası hemen gösterilmeli ve numarayı veritabanı veriyor.
 */
export async function createKioskOrder(
  tenantId: string,
  admin: AdminUser,
  lines: OrderLine[],
): Promise<KioskReceipt> {
  if (!supabase) throw new Error('Bağlantı yok.')
  const id = crypto.randomUUID()
  const row = orderToRow(tenantId, {
    id,
    receiptNo: '',
    dayKey: toDayKey(),
    deviceId: getDeviceCode(),
    cashierUid: admin.uid,
    cashierEmail: admin.email,
    openedByName: 'Kiosk',
    openedByUid: admin.uid,
    lines,
    itemCount: lines.reduce((n, l) => n + l.qty, 0),
    totalKurus: lines.reduce((n, l) => n + l.lineTotalKurus, 0),
    status: 'open',
    awaitingPayment: true,
    source: 'kiosk',
    createdAtLocal: Date.now(),
  })
  const { data, error } = await supabase
    .from('orders')
    .insert(row)
    .select('takeaway_no, track_token, pickup_code')
    .single()
  if (error) throw new Error('Sipariş gönderilemedi. Lütfen kasaya başvurun.')
  return {
    id,
    takeawayNo: typeof data?.takeaway_no === 'number' ? data.takeaway_no : null,
    trackToken: typeof data?.track_token === 'string' ? data.track_token : null,
    pickupCode: typeof data?.pickup_code === 'string' ? data.pickup_code : null,
  }
}
